import {
  Page,
  Document,
  PDFViewer,
  Image,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import { Request } from "../../hooks/Request";
import dayjs from "dayjs";
import { numberWithDecimals } from "../../utils/validate";
import CustomTablePDF from "../../components/GeneratePdf/CustomTablePDF";
import { useAuth } from "../../contexts/AuthContext";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 9,
    paddingTop: 30,
    paddingBottom: 37,
    paddingHorizontal: 30,
  },
  header: {
    position: "absolute",
    top: -1.2,
    right: "20px",
    zIndex: -10,
  },
  styleFormat: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
    width: "612px",
    height: "792px",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 3,
    fontSize: 9,
    padding: 0,
  },
  bold: {
    fontFamily: "Helvetica-Bold",
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
});

// Componente principal
const PDFDocument = ({ data, dataHoja, procedureTypeId }) => {
  // const { user } = useAuth();
  // const fondoURL =
  //   user?.institutionParam?.find((x) => x.code === "logo")?.value ?? null;
  // Extraer datos necesarios
  const company = data.company || {};
  const factura = data.facturaComercial || "";
  const dam = data["a1N°DeDeclaración(Dam)"] || "";
  const dim = data.a1NúmeroDeDeclaración || "";
  const dav = data.internoDeDav || "";
  const aduana = data.a4AduanaDeDespacho || "";
  const canal = data["canal(Rojo,AmarilloOVerde)"] || "";
  const proveedor = data.e1DatosDelProveedor || "";
  const mercaderia = data.descripciónDeLaMercancía || "";

  // Obtener fechas de procedimientos
  const getProcedureDate = (step) => {
    const procedure = dataHoja.procedureHistories?.find(
      (item) => item.step === step,
    );
    return procedure?.initialDate
      ? dayjs(procedure.initialDate).format("DD/MM/YYYY HH:mm:ss")
      : "";
  };

  function convertNumberToCurrency(str) {
    return numberWithDecimals(Number(String(str).replace(/,/g, "")));
  }

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {/* Formato de fondo */}
        <View style={styles.styleFormat} fixed>
          <Image
            src="https://res.cloudinary.com/dh15miacl/image/upload/fondo_bffzk1.jpg"
            // src={fondoURL}
            // src="https://res.cloudinary.com/joeldes/image/upload/v1751556894/DeliveryDay/reports/DD_formato-informe_xdmzwo.jpg"
            style={{
              position: "absolute",
              top: "0%",
              left: "0%",
              width: "105%", // mantienes tu tamaño mayor
              height: "100%", // centra la imagen
              opacity: 0.3,
            }}
          />
        </View>

        {/* Encabezado */}
        <View style={{ marginBottom: 10 }}>
          <View
            style={{
              border: "1px solid black",
              borderBottom: "none",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "31.7%",
              }}
            >
              <Image
                src="https://res.cloudinary.com/joeldes/image/upload/v1772644553/Patross/logo-patross_y0s6vl.png"
                style={{ height: "50px", width: "50px" }}
              />
              {/* <Image
                src="https://res.cloudinary.com/joeldes/image/upload/v1704774719/Agda/logoOEA_nceuhb.png"
                style={{ height: "40px", width: "40px" }}
              /> */}
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "65%",
              }}
            >
              <Text style={[styles.bold, styles.center, { fontSize: 14 }]}>
                HOJA DE RUTA
              </Text>
            </View>
            <View
              style={{
                borderLeft: "1px solid black",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "30%",
              }}
            >
              <Text style={[{ width: "120px" }, styles.bold]}>
                N° TRAMITE {data.a3NúmeroDeReferencia || data.codigoDeInterno}
              </Text>
            </View>
          </View>

          <View style={[styles.table, { marginBottom: 10 }]}>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "25%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  Código: RAJP.09.08
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "25%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  Versión: 1.0
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "25%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  N° TRAMITE {data.a3NúmeroDeReferencia || data.codigoDeInterno}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "25%" }]}>
                <Text style={styles.tableCell}>Fecha aprob.: -</Text>
              </View>
            </View>
          </View>

          {/* Información del cliente */}
          <View style={[styles.table, { marginBottom: 10 }]}>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "100%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  Cliente: {company.razonSocial || "-"}
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "50%" }]}>
                <Text style={styles.tableCell}>NIT: {company.nit || "-"}</Text>
              </View>
              <View style={[styles.tableCol, { width: "50%" }]}>
                <Text style={styles.tableCell}>
                  Mercadería: {mercaderia || "-"}
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "50%" }]}>
                <Text style={styles.tableCell}>Factura: {factura || "-"}</Text>
              </View>
              <View style={[styles.tableCol, { width: "50%" }]}>
                <Text style={styles.tableCell}>Aduana: {aduana || "-"}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "50%" }]}>
                <Text style={styles.tableCell}>Frontera: -</Text>
              </View>
              <View style={[styles.tableCol, { width: "50%" }]}>
                <Text style={styles.tableCell}>
                  Patrón:{" "}
                  {data.asignarRégimenDeImportación ||
                    data["a5Destino/RégimenAduanero"]}
                </Text>
              </View>
            </View>
            {/* <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "100%" }]}>
                <Text style={styles.tableCell}>
                  Nro Carpeta: {dim || "DES2145AVV"}
                </Text>
              </View>
            </View> */}
          </View>

          {/* Tabla principal de hoja de ruta */}
          <View style={[styles.table, { marginBottom: 10 }]}>
            {/* RECEPCION */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>RECEPCION</Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>
                  Fecha Inicio: {getProcedureDate(1) || "-"}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>
                  Responsable: {data.designacionDeLiquidador || "-"}
                </Text>
              </View>
            </View>

            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  {"ANALISIS Y\nPROCESAMIENTO"}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>
                  Fecha Asignación:{" "}
                  {getProcedureDate(6) || "08/09/2025 12:24:02"}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>
                  Liquidador: {data.designacionDeLiquidador || "-"}
                </Text>
              </View>
            </View>

            {/* DESPACHO ADUANERO */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  {"DESPACHO\nADUANERO"}
                </Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  { width: "80%", flexDirection: "column" },
                ]}
              >
                <View style={{ flexDirection: "row" }}>
                  {/* <Text style={[styles.tableCell, { width: "50%" }]}>
                    Aceptación de la DIM
                  </Text> */}
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    DIM: {dim || "-"}
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    CANAL: {canal || "-"}
                  </Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Fecha Inicio: {getProcedureDate(1) || "-"}
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Aceptación: {getProcedureDate(5) || "-"}
                  </Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Fecha Pago Tributos: {getProcedureDate(5) || "-"}
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "100%" }]}>
                    Observaciones Gestor: {data.asignarGestor || ""}
                  </Text>
                </View>
              </View>
            </View>

            {/* FACTURACION */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>FACTURACION</Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>
                  Fecha Recepción de carpeta: {getProcedureDate(8)}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Nº Factura: {factura || "-"}
                  </Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Fecha Factura: {getProcedureDate(12) || "-"}
                  </Text>
                </View>
                <Text style={styles.tableCell}>Elaborado por: {"-"}</Text>
              </View>
            </View>

            {/* ENVIO DE DOCUMENTOS AL CLIENTES */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  {"ENVIÓ DE\nDOCUMENTOS AL CLIENTES"}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>
                  Fecha: {getProcedureDate(14)}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "40%" }]}>
                <Text style={styles.tableCell}>Entregado Por:</Text>
              </View>
            </View>

            {/* ARCHIVO */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>ARCHIVO</Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  { width: "80%", flexDirection: "column" },
                ]}
              >
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Recepción y Verificación Fecha/Hora:
                  </Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Recepciondo por:
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Observaciones Revisión Posterior Fecha/Hora:
                  </Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Responsable:
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Digitalicación Archivado Fecha/Hora:
                  </Text>
                  <Text style={[styles.tableCell, { width: "50%" }]}>
                    Archivado por: {data.designacionDeLiquidador || "-"}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* Tabla de información adicional */}
          <View style={[styles.table, { marginBottom: 10 }]}>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  Tipo despacho:
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={styles.tableCell}>
                  {procedureTypeId === 1
                    ? "Importacion"
                    : procedureTypeId === 2
                      ? "Exportacion"
                      : "-"}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  Tipo Mercadería:
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={styles.tableCell}>{mercaderia}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>Cant. ITEM:</Text>
              </View>
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={styles.tableCell}>
                  {data.f2TotalNúmeroDeItems || "0"}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.bold]}>
                  MERCADERIA BASE IMPONIBLE
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={styles.tableCell}>0.00</Text>
              </View>
            </View>
          </View>

          {/* Tabla de valores */}
          <View style={[styles.table, { marginBottom: 10 }]}>
            {[
              [
                "Fob Total:",
                `${data["e15ValorFobTotal"] ? convertNumberToCurrency(data["e15ValorFobTotal"]) : "0"}`,
                "Total K.B.:",
                `${data["f4TotalPesoBruto"] ? convertNumberToCurrency(data["f4TotalPesoBruto"]) : "0"}`,
              ],
              [
                "Fletes I,II:",
                "-",
                "Total K.N.",
                `${data["f5TotalPesoNeto"] ? convertNumberToCurrency(data["f5TotalPesoNeto"]) : "0"}`,
              ],
              [
                "Seguros:",
                `${data["f8TotalCostoDelSeguro"] ? convertNumberToCurrency(data["f8TotalCostoDelSeguro"]) : "0"}`,
                "Total Bullos:",
                `${data["f3TotalNúmeroDeBultos"] ? convertNumberToCurrency(data["f3TotalNúmeroDeBultos"]) : "0"}`,
              ],
              [
                "Otros Gastos:",
                `${data["f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos"] ? convertNumberToCurrency(data["f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos"]) : "0"}`,
                "",
                "",
              ],
              [
                "Otras Erogaciones:",
                `${data["e24OtrasOrogaciones"] ? convertNumberToCurrency(data["e24OtrasOrogaciones"]) : "0"}`,
                "",
                "",
              ],
              ["Deducciones:", "-", "", ""],
              [
                "Total Cif Sus.",
                `${data["f10TotalValorCifAduana"]
                  ? convertNumberToCurrency(
                    Number(
                      String(data["f10TotalValorCifAduana"]).replace(
                        /,/g,
                        "",
                      ),
                    ) /
                    Number(
                      String(data["e16TipoDeCambio"]).replace(/,/g, ""),
                    ),
                  )
                  : "0"
                }`,
                "",
                "",
              ],
              [
                "T.C.",
                `${data["e16TipoDeCambio"] ? convertNumberToCurrency(data["e16TipoDeCambio"]) : "0"}`,
                "-",
                "",
              ],
              [
                "total Cif Bs.",
                `${data["f10TotalValorCifAduana"] ? convertNumberToCurrency(data["f10TotalValorCifAduana"]) : "0"}`,
                "",
                "",
              ],
            ].map((row, idx) => (
              <View key={idx} style={styles.tableRow}>
                <View style={[styles.tableCol, { width: "25%" }]}>
                  <Text style={[styles.tableCell, styles.bold]}>{row[0]}</Text>
                </View>
                <View style={[styles.tableCol, { width: "25%" }]}>
                  <Text style={styles.tableCell}>{row[1]}</Text>
                </View>
                <View style={[styles.tableCol, { width: "25%" }]}>
                  <Text style={[styles.tableCell, styles.bold]}>{row[2]}</Text>
                </View>
                <View style={[styles.tableCol, { width: "25%" }]}>
                  <Text style={styles.tableCell}>{row[3]}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </Page>
      <Page size="LETTER" style={styles.page}>
        <View style={styles.styleFormat} fixed>
          <Image
            src="https://res.cloudinary.com/dh15miacl/image/upload/fondo_bffzk1.jpg"
            style={{
              position: "absolute",
              top: "0%",
              left: "0%",
              width: "105%", // mantienes tu tamaño mayor
              height: "100%", // centra la imagen
              opacity: 0.3,
            }}
          />
        </View>
        {/* Tabla de documentos */}
        <View style={[styles.table, { marginBottom: 10 }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { width: "10%" }]}>
              <Text style={[styles.tableCell, styles.bold, styles.center]}>
                Nº
              </Text>
            </View>
            <View style={[styles.tableCol, { width: "70%" }]}>
              <Text style={[styles.tableCell, styles.bold, styles.center]}>
                Documento
              </Text>
            </View>
            <View style={[styles.tableCol, { width: "20%" }]}>
              <Text style={[styles.tableCell, styles.bold, styles.center]}>
                Estado
              </Text>
            </View>
          </View>
          {data.documentosSeccionLSubDatas?.slice(0, 2).map((doc, idx) => (
            <View key={idx} style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "10%" }]}>
                <Text style={[styles.tableCell, styles.center]}>{idx + 1}</Text>
              </View>
              <View style={[styles.tableCol, { width: "70%" }]}>
                <Text style={styles.tableCell}>{doc.label || "Documento"}</Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={[styles.tableCell, styles.center]}>-</Text>
              </View>
            </View>
          ))}
        </View>
        <View style={[styles.table, { marginBottom: 10 }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { width: "100%" }]}>
              <Text style={[styles.tableCell, styles.bold]}>Incidencias:</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { width: "100%", height: "60px" }]}>
              <Text style={styles.tableCell}></Text>
            </View>
          </View>
        </View>
        <Text
          bold
          borderContent
          style={{ marginTop: "5px", marginBottom: "5px" }}
        >
          TRAZABILIDAD POR PROCESOS
        </Text>
        <CustomTablePDF
          fields={[
            // {
            //   label: 'Nro',
            //   name: 'label',
            //   width: '5',
            // },
            {
              label: "Encargado",
              name: "userInChange",
              width: "24",
            },
            {
              label: "Proceso",
              name: "stepName",
              width: "19",
            },
            {
              label: "Inicio",
              name: "initialDate",
              type: "date",
              width: "13",
            },
            {
              label: "Final",
              name: "finalDate",
              type: "date",
              width: "13",
            },
            {
              label: "Duración",
              name: "durationString",
              width: "31",
            },
          ]}
          data={dataHoja.procedureHistories}
          border={{ right: true, bottom: true, left: true, top: true }}
        />
      </Page>
    </Document>
  );
};

// Componente principal de exportación
export const GenerateRoadmapPDF = ({ procedure }) => {
  console.log("🚀 ~ GenerateRoadmapPDF ~ procedure:", procedure);
  const FIELD_NAMES = [
    "asignarRégimenDeImportación",
    "modalidadDeDespacho",
    "descripciónDeLaMercancía",
    "partidaArancelaria",
    "tributosAduaneros",
    "gastosNoFacturados",
    "gastosFacturados",
    "honorariosProfesionales",
    "pagos",
    "f2TotalNúmeroDeItems",
    "e1DatosDelProveedor",
    "asignarGestor",
    "proveedor",
    "canal(Rojo,AmarilloOVerde)",
    "designacionDeLiquidador",
    "codigoDeInterno",
    "a4AduanaDeDespacho",
    "a1NúmeroDeDeclaración",
    "a1N°DeDeclaración(Dam)",
    "a3NúmeroDeReferencia",
    "a5Destino/RégimenAduanero",
    "internoDeDav",
    "facturaComercial",
    "fleteI(Usd)",
    "fleteII(Usd)",
    "f6TotalValorFob",
    "f7GastosTransHastaElLugarDeImportación",
    "f8TotalCostoDelSeguro",
    "f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos",
    "g1TributosDeterminadosGa",
    "g2TributosDeterminadosIva",
    "g4TributosDeterminadosIce",
    "instruciones(RecepcionDeDocumentos)",
    "instruciones(LiquidacionesArmadoDeCarpeta)",
    "instruciones(CanalYGestoria)",
    "instruciones(Adm_Financiera)",
    "instruciones(Archivos)",
    "documentosSeccionL",

    "e15ValorFobTotal",
    "f4TotalPesoBruto",
    "f5TotalPesoNeto",
    "f3TotalNúmeroDeBultos",
    "f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos",
    "e24OtrasOrogaciones",
    "f10TotalValorCifAduana",
    "e16TipoDeCambio",
  ];

  const buildFieldsQuery = () =>
    FIELD_NAMES.map((field) => `fieldnames=${field}`).join("&");

  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.id || procedure.procedureId
      }/dataValues?${buildFieldsQuery()}`,
  });

  const { data: dataHoja, loading: loadingHoja } = Request({
    urlApi: `/tradecruz/${procedure.id || procedure.procedureId}/HojaDeRuta`,
  });

  if (!loading || !loadingHoja) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <p>Cargando documento...</p>
      </div>
    );
  }

  if (!data || !dataHoja) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <p>Error: No se pudieron cargar los datos del procedimiento.</p>
      </div>
    );
  }

  return (
    <div>
      <PDFViewer style={{ width: 900, height: window.innerHeight - 100 }}>
        <PDFDocument
          data={data}
          dataHoja={dataHoja}
          procedureTypeId={procedure.procedureTypeId}
        />
      </PDFViewer>
    </div>
  );
};
